import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

// Auth Services
import { environment } from '../../../environments/environment';
import { EncryptionService } from '../services/encryption.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private encryptionService: EncryptionService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        let rememberMe: boolean;
        let storedAdminInfo: any;

        if (localStorage.getItem('rememberMe')) {
            rememberMe = true;
        } else {
            rememberMe = false;
        }

        rememberMe ? storedAdminInfo = localStorage.getItem('storedAdminInfo') :
            storedAdminInfo = sessionStorage.getItem('storedAdminInfo');

        // storedAdminInfo ? storedAdminInfo = JSON.parse(storedAdminInfo) : storedAdminInfo = {};
        if (storedAdminInfo) {
            try {
                const decryptedData = this.encryptionService.decrypt(storedAdminInfo);
                if (decryptedData) {
                    storedAdminInfo = JSON.parse(decryptedData);
                    if (storedAdminInfo.user_id) {
                        if (state.url === '/') {
                            // Check if hashed_node_id exists and redirect to filemanager
                            if (storedAdminInfo.hashed_node_id) {
                                this.router.navigate([`/filemanager/${storedAdminInfo.hashed_node_id}`]);
                                return false; // Prevent further navigation to the root route
                            }
                        }
                        return true;
                    }
                }
            } catch (e) {
                console.error('Error parsing stored admin info:', e);
            }
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['auth/user-login']);
        return false;
    }
}
